import React from "react";
import { getPayrollOverallSummaryPresentation } from "../../../helpers/payrollReport";
import { ReportRule } from "../../report/ReportRule";

export function PayrollReportOverallSummarySection({
  reportModel,
  variant = "preview",
}) {
  const presentation = getPayrollOverallSummaryPresentation(reportModel);
  if (!presentation) return null;

  const isPrint = variant === "print";
  const sectionClass = isPrint ? "erp-section erp-break-avoid" : undefined;
  const titleClass = isPrint ? "erp-section-title" : "er-section-title";
  const rowClass = isPrint ? "erp-totals-row" : "er-summary-row";
  const emphasisRowClass = isPrint
    ? "erp-totals-row erp-totals-row--grand"
    : "er-summary-row er-summary-row--emphasis";
  const blockClass = isPrint ? "erp-totals-block" : "er-report-totals";

  const content = (
    <>
      <ReportRule variant={isPrint ? "print" : "preview"} />
      <h2 className={titleClass}>{presentation.title}</h2>
      <div className={isPrint ? "erp-totals-wrap" : "er-totals-wrap"}>
        <div className={blockClass}>
          {presentation.lines.map((line) => (
            <div
              key={line.key}
              className={line.emphasis ? emphasisRowClass : rowClass}
            >
              <span>{line.label}</span>
              <span>{line.value}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );

  if (isPrint) {
    return <section className={sectionClass}>{content}</section>;
  }

  return content;
}
